import axios from 'axios';
import { API_BASE_URL } from '../config';

function getCsrfToken() {
    return document.cookie.split('; ')
        .find(row => row.startsWith('csrftoken='))
        ?.split('=')[1];
}

export const getBankAnalytics = async (year) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/bank-analytics/?year=${year}`, {
            headers: {
                'X-CSRFToken': getCsrfToken(),
            },
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching bank analytics:', error);
        throw error;
    }
};
